/*
 * Converts a value to HH:mm (24-hour clock) format, checking for validity according to ISO 8601 format.
 * @param input - ISO 8601 format string (e.g. PT1H15M, PT0S).
 * @returns HH:mm format string.
 */
export function convertTo24HourTime(input: string): string {
  const iso8601Regex = /^PT(?:(\d+)H)?(?:(\d+)M)?$/;

  if (!input || typeof input !== 'string' || !iso8601Regex.test(input)) {
    return '00:00';
  }

  const match = iso8601Regex.exec(input);
  const hours = parseInt(match?.[1] || '0', 10);
  const minutes = parseInt(match?.[2] || '0', 10);

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
